import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;

    let ringX = -100, ringY = -100;
    let dotX = -100, dotY = -100;
    let raf;

    const onMove = (e) => {
      dotX = e.clientX;
      dotY = e.clientY;
      dot.style.left = dotX + "px";
      dot.style.top = dotY + "px";
    };

    const animate = () => {
      ringX += (dotX - ringX) * 0.12;
      ringY += (dotY - ringY) * 0.12;
      ring.style.left = ringX + "px";
      ring.style.top = ringY + "px";
      raf = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    raf = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="cursor-dot" style={{ left: "-100px", top: "-100px" }} />
      <div ref={ringRef} className="cursor-ring" style={{ left: "-100px", top: "-100px" }} />
    </>
  );
}
